import styled from 'styled-components';
import { SECONDARY_COLOR, SECONDARY_COLOR_3, SECONDARY_COLOR_4, SECONDARY_COLOR_6 } from '../../const/color';
import { MinusIcon, PlusIcon } from '../../const/icons';
import { TITLE_SIZE_5 } from '../../const/text';

export const Container = styled.div`
  width: 120px;
  height: 40px;
  display: flex;
  background-color: ${SECONDARY_COLOR_6};
  border-radius: 2px;
  padding: 2px;
  font-size: ${TITLE_SIZE_5}px;
  justify-content: space-between;
`;

export const Value = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  font-family: Arial, serif;
  color: ${SECONDARY_COLOR};
`;

export const Button = styled.div<{ minus?: boolean }>`
  border-radius: 2px;
  background-color: white;
  background-size: 16px;
  background-repeat: no-repeat;
  background-position: center;
  width: 38px;
  height: 36px;
  cursor: pointer;
  &:hover {
    background-color: ${SECONDARY_COLOR_4};
  }
  &:active {
    background-color: ${SECONDARY_COLOR_3};
  }
  background-image: url("data:image/svg+xml,${props => props.minus ? MinusIcon() : PlusIcon()}");
`;